import { useTranslation } from "../../../../../hooks/useTranslation";
import { AddRestrictionButton } from "../../../components/AddRestrictionButton";
import { useGetLocale } from "@refinedev/core";
import { GridColDef } from "@mui/x-data-grid";
import { useMemo } from "react";
import { PaginatedList } from "../../../../../components/form/PaginatedList/PaginatedList";

type RestrictedKeyword = {
  id: string;
  word: string;
  created: string;
};

export const RestrictedKeywords = () => {
  const { translate } = useTranslation(
    "pages.storeSecurity.restrictions.restrictedKeywords",
  );

  const locale = useGetLocale();
  const currentLocale = locale();

  const columns = useMemo<GridColDef<RestrictedKeyword>[]>(
    () => [
      {
        field: "word",
        headerName: translate("list.fields.keyword"),
        flex: 2,
        minWidth: 150,
      },
      {
        field: "created",
        headerName: translate("list.fields.createDate"),
        flex: 1,
        valueFormatter: (value: string) => {
          const date = new Date(value).toLocaleDateString(currentLocale);
          const time = new Date(value).toLocaleTimeString(currentLocale);

          return `${date} ${time}`;
        },
      },
    ],
    [currentLocale],
  );

  return (
    <PaginatedList
      addButton={
        <AddRestrictionButton
          translationPrefix="pages.storeSecurity.restrictions.restrictedKeywords.addDialog"
          endpoint="store/restrictions/word"
        />
      }
      getUrl={(countryId) => `store/${countryId}/restrictions/word`}
      columns={columns}
      searchLabel={translate("list.filters.search")}
    />
  );
};
